module.exports = __webpack_public_path__ + "img/login.83cad7d1.png";